module.exports = __webpack_public_path__ + "static/img/donation.ca30083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taoyuan/donation.png
// module id = l1CC
// module chunks = 1